import ApiClient from './Api-client';
import store from '../store';
import {
    setPermissions,
    setPermissionsLoading,
    setPermissionsError,
    clearPermissions,
} from '../core/store/redux/slices/Permission-slice';

const { authApi } = ApiClient();

export const fetchPermissions = async () => {
    try {
        store.dispatch(setPermissionsLoading());
        const response = await authApi.get('/permissions/me', null, 'Failed to fetch permissions');
        if (response?.data?.data) {
            store.dispatch(setPermissions(response.data.data));
        }
    } catch (error) {
        console.error('Failed to fetch permissions:', error);
        store.dispatch(setPermissionsError(error?.message || 'Failed to fetch permissions'));
    }
};

export const clearUserPermissions = () => {
    store.dispatch(clearPermissions());
};
